$(document).ready(function () {
  $(".collection_slide").slick({
    dots: false,
    leftMode: true,
    arrows: false,
    leftPadding: "0px",
    slidesToShow: 3.1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    accessibility: false,
    asNavFor: ".slider-nav",
    infinite: false, 
  });
  $(".slider-nav").slick({
    slidesToShow: 4,
    infinite: false,    
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    centerMode: true,
    centerPadding: "40px",
    focusOnSelect: true,
    vertical: true,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="14" viewBox="0 0 25 14" fill="none"><path d="M0.409912 13L6.40991 7L12.4099 1L24.4099 13" stroke="#282828" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="14" viewBox="0 0 25 14" fill="none"><path d="M0.409912 1.28003L12.4099 13.28L24.4099 1.28003" stroke="#282828" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 990,
        settings: {
          vertical: false,
          dots: true,
        },
      },
    ],
  });
  $('.quantity__input').change(function(){
    var qty = $(this).val();
    $('.cust_hidden_qty').val(qty)
  });
});
